import { createContext, useContext, useState } from 'react';

interface IObjectReplacerContext {
  selectedImage: File | null;
  setSelectedImage: (image: File | null) => void;
  selectedQuality: string;
  setSelectedQuality: (quality: string) => void;
  generatedImage: string | null;
  setGeneratedImage: (image: string | null) => void;
}

const ObjectReplacerProvider = createContext<IObjectReplacerContext>({
  selectedImage: null,
  setSelectedImage: () => {},
  selectedQuality: 'medium',
  setSelectedQuality: () => {},
  generatedImage: null,
  setGeneratedImage: () => {},
});

export default function ObjectReplacerContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const [selectedQuality, setSelectedQuality] = useState('medium');
  const [generatedImage, setGeneratedImage] = useState<string | null>(null);

  return (
    <ObjectReplacerProvider.Provider
      value={{
        selectedImage,
        setSelectedImage,
        selectedQuality,
        setSelectedQuality,
        generatedImage,
        setGeneratedImage,
      }}
    >
      {children}
    </ObjectReplacerProvider.Provider>
  );
}

export const useObjectReplacerContext = () => {
  return useContext(ObjectReplacerProvider);
};
